module.exports = __webpack_public_path__ + "static/img/01.c616ec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/140219/01.png
// module id = DxYk
// module chunks = 0